module.exports = __webpack_public_path__ + "static/media/calendar-2.bcd1d99d.svg";